import React from "react";
import Futuro from "../assets/Futuro.jpeg";

const FuturoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Futuro}
            alt="Futuro"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">
          O futuro se constrói no presente
          </h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            <br />
            Para alcançar o futuro que deseja, é necessário começar a construí-lo no presente. Nunca é cedo ou tarde demais para (re)começar.
            <br />
            <br />
            Como você está investindo em si?
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default FuturoPage;
